import { Icon, type TIconProps } from '~/components/icon'

import type { TButtonSizes, TButtonVariants } from '../../types'

import { useButtonProps } from '../../hooks/use-button-props'

interface IButtonIconProps extends Pick<TIconProps, 'symbol'> {
  testID?: string
}

export function ButtonIcon({ symbol, testID }: IButtonIconProps) {
  const { variant = 'brand-primary', size = 'md', disabled } = useButtonProps()

  const isDisabled = !!disabled

  const iconColorMapping: Record<TButtonVariants, TIconProps['color']> = {
    'brand-primary': 'colorTextNeutralInverse',
    'neutral-secondary': 'colorTextNeutralDefault',
    'neutral-tertiary': 'colorTextNeutralDefault',
  }

  const iconSizeMapping: Record<TButtonSizes, TIconProps['size']> = {
    md: 'tiny',
    ml: 'small',
    lg: 'small',
    xl: 'small',
  }

  return (
    <Icon
      symbol={symbol}
      size={iconSizeMapping[size]}
      color={
        isDisabled ? 'colorTextNeutralDisabled' : iconColorMapping[variant]
      }
      testID={testID}
    />
  )
}
